import { BrowserRouter, Route } from "react-router-dom";
import Navbar from "./components/navbar/navbar";
import Footer from "./components/footer/footer";
import healthFacilitiesScreen from "./layouts/health-facilities-screen/health-facilities-screen";
import HomeScreenSection from "./layouts/home-screen/home-screen-section";
import SuppliersScreen from "./layouts/suppliers-screen/suppliers-screen";
import ScrollToTop from "./utils/scroll-to-top";

const App = () => (
  <BrowserRouter>
    <Navbar />
    <Route path="/" exact component={HomeScreenSection} />
    <Route path="/health-facilities" component={healthFacilitiesScreen} />
    <Route path="/medical-suppliers" component={SuppliersScreen} />
    <Footer />
    <ScrollToTop />
  </BrowserRouter>
);

export default App;
